export function fullHeightPage() {
    const $body = $("body");
    const $headerMenuOpener = $(".header").find(".header-menu-opener");

    function setHeight() {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
    }

    setHeight();
    window.addEventListener("resize", function () {
        if ($body.hasClass("no-touch")) {
            setHeight();
        }
    });
    window.addEventListener("orientationchange", function () {
        setHeight();
    });
    $headerMenuOpener.on("click", function () {
        setHeight();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/fullHeightPage.js